import { render, staticRenderFns } from "./DialogRevoke.vue?vue&type=template&id=3be2009c&"
import script from "./DialogRevoke.vue?vue&type=script&lang=js&"
export * from "./DialogRevoke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports